/* MoreDetails.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { UserGeneratedHTML } from '@atlassian/mpac-primitives';
import { TEST_ID } from './constants';
import { Section } from './Section';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._1nmz1hna{word-break:break-word}";
const containerStyle = null;
export const MoreDetails = _ref => {
  let {
    moreDetails
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Section.Heading, {
      as: "h2",
      children: "More details"
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_1nmz1hna"]),
        children: /*#__PURE__*/_jsx(UserGeneratedHTML, {
          dangerousHTML: moreDetails,
          "data-testid": TEST_ID.OVERVIEW_TAB_MORE_DETAILS_CONTENT
        })
      })]
    })]
  });
};